<template>
	<div class="page-news">
		<HeadBanner
			v-if="_.get($store.state, 'selected_menu')"
			:itemData="_.get($store.state, 'selected_menu')"
		/>
		<Breadcrumb />

		<div class="news-head mt-55">
			<NewsMediaFilter
				@get-search-text="getSearchText"
				@get-search-date="getSearchDate"
				@get-search-select="getSearchSelect"
			/>
		</div>

		<template
			v-if="_.get($store.state.current_content, 'primary_conf.listCount')"
		>
			<section
				class="container news-section bg-white"
				:class="{ hide: pageChange }"
				v-if="_.get($store.state, 'locale')"
			>
				<div class="news-main-boxes flex-box between">
					<template v-for="(headPost, index) in mainList">
						<article
							class="article-left"
							:key="headPost.id"
							v-if="index === 0"
							:class="{ video: headPost.video }"
						>
							<router-link :to="$store.getters.getSingleUrl(headPost, 1)">
								<div class="img-box">
									<picture>
										<source
											media="(max-width: 767px)"
											:srcset="_.get(firstImageSourceGetter(headPost, ['cover_image', 'images']), '0.devices.mobile')"
										/>
										<source
											media="(max-width: 1023px)"
											:srcset="_.get(firstImageSourceGetter(headPost, ['cover_image', 'images']), '0.devices.tablet')"
										/>
										<img
											:src="_.get(firstImageSourceGetter(headPost, ['cover_image', 'images']), '0.devices.desktop')"
											class="img-absolute"
											alt
										/>
									</picture>
									<div class="gradient"></div>
									<div class="img-overlay"></div>
									<div class="date mob btn-20 bg-white">
										<span>{{
											moment(headPost.date).format('DD MM YYYY')
										}}</span>
									</div>
								</div>
								<div class="article-left-content">
									<div class="date btn-20 bg-white">
										<span>{{
											moment(headPost.date).format('DD MM YYYY')
										}}</span>
									</div>
									<h1 class="other-title white">
										{{ headPost.title }}
									</h1>
									<div class="btn sub">
										{{ $fn.tr('read more') }}
									</div>
								</div>
							</router-link>
						</article>
					</template>

					<article class="article-right">
						<template v-for="(rightPost, index) in mainList">
							<router-link
								:to="$store.getters.getSingleUrl(rightPost)"
								class="flex-box column"
								:key="rightPost.id"
								v-if="index === 1"
								:class="{ video: rightPost.video }"
							>
								<div class="img-box">
									<picture>
										<source
											media="(max-width: 767px)"
											:srcset="_.get(firstImageSourceGetter(rightPost, ['cover_image', 'images']), '0.devices.mobile')"

										/>
										<source
											media="(max-width: 1023px)"
											:srcset="_.get(firstImageSourceGetter(rightPost, ['cover_image', 'images']), '0.devices.tablet')"

										/>
										<img
											:src="_.get(firstImageSourceGetter(rightPost, ['cover_image', 'images']), '0.devices.tablet')"

											class="img-absolute"
											alt
										/>
									</picture>
									<div class="img-overlay"></div>
									<div class="date-box btn-20 bg-white">
										<span>{{
											moment(rightPost.date).format('DD MM YYYY')
										}}</span>
									</div>
								</div>
								<div class="news-text-box bg-white flex-box column">
									<h2 class="news-title">{{ rightPost.title }}</h2>
									<div class="text mt-21">
										{{ rightPost.teaser }}
									</div>
									<div class="read-btn blue font-12 noto-semibold">
										{{ $fn.tr('read more') }}
									</div>
								</div>
							</router-link>
						</template>
					</article>
				</div>
			</section>
			<section class="container">
				<div
					class="news-container flex-box wrap"
					:class="{ hide: pageChange }"
					v-if="getNews !== undefined"
				>
					<router-link
						:to="$store.getters.getSingleUrl(news)"
						class="news-item flex-box column"
						v-for="news in mainList.slice(2)"
						:key="news.id"
						:class="{ video: news.video }"
					>
						<div class="img-box">
							<picture>
								<source
									media="(max-width: 767px)"
									:srcset="_.get(firstImageSourceGetter(news, ['cover_image', 'hover_image', 'images']), '0.devices.mobile')"
								/>
								<source
									media="(max-width: 1023px)"
									:srcset="_.get(firstImageSourceGetter(news, ['cover_image', 'hover_image', 'images']), '0.devices.tablet')"
								/>
								<img
									:src="_.get(firstImageSourceGetter(news, ['cover_image', 'hover_image', 'images']), '0.devices.desktop')"
									class="img-absolute"
									alt
								/>
							</picture>
							<div class="img-overlay"></div>
							<div class="date-box btn-20 bg-white">
								<span>{{ moment(news.date).format('DD MM YYYY') }}</span>
							</div>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="100.002"
								height="99.999"
								viewBox="0 0 100.002 99.999"
							>
								<path
									id="Subtraction_136"
									data-name="Subtraction 136"
									d="M-16441,1051a49.691,49.691,0,0,1-19.463-3.929,49.828,49.828,0,0,1-15.895-10.716,49.829,49.829,0,0,1-10.715-15.893A49.662,49.662,0,0,1-16491,1001a49.662,49.662,0,0,1,3.93-19.462,49.829,49.829,0,0,1,10.715-15.893,49.826,49.826,0,0,1,15.895-10.715A49.689,49.689,0,0,1-16441,951a49.689,49.689,0,0,1,19.463,3.929,49.81,49.81,0,0,1,15.893,10.715,49.775,49.775,0,0,1,10.715,15.893A49.662,49.662,0,0,1-16391,1001a49.663,49.663,0,0,1-3.93,19.462,49.777,49.777,0,0,1-10.715,15.893,49.814,49.814,0,0,1-15.893,10.716A49.691,49.691,0,0,1-16441,1051Zm-7.713-66.533a3.008,3.008,0,0,0-3.006,3v27.059a3.008,3.008,0,0,0,3.006,3,2.97,2.97,0,0,0,1.506-.414l23.193-13.529a2.972,2.972,0,0,0,1.488-2.591,2.972,2.972,0,0,0-1.488-2.591l-23.193-13.529A2.945,2.945,0,0,0-16448.711,984.468Z"
									transform="translate(16491 -951.002)"
									fill="#fff"
									opacity="0.8"
								/>
							</svg>
						</div>
						<div class="news-text-box flex-box column">
							<h3 class="news-title">{{ news.title }}</h3>
							<div class="read-btn blue font-12 noto-semibold">
								{{ $fn.tr('read more') }}
							</div>
						</div>
					</router-link>
				</div>
			</section>
		</template>
		<div
			class="news-not-found container mt-34 noto-semibold"
			v-if="!_.get($store.state.current_content, 'primary_conf.listCount')"
		>
			{{ $fn.tr('News not found') }}
		</div>

		<div class="news-pagination">
			<Pagination2
				:pageNumber="filter.pageNumber"
				:perPage="filter.perPage"
				:dataLength="getDataLength"
				@set-current="setCurrent"
			/>
		</div>
	</div>
</template>

<script>
	import HeadBanner from '@/components/HeadBanner';
	import Breadcrumb from '@/components/Breadcrumb';
	import NewsMediaFilter from '@/components/NewsMediaFilter';
	import Pagination2 from '@/components/Pagination2';
	import moment from 'moment';
	import otherMixin from "../mixins/other";

	export default {
		mixins: [otherMixin],

		components: {
			HeadBanner,
			Breadcrumb,
			NewsMediaFilter,
			Pagination2,
		},

		data() {
			return {
				perPage: parseInt(
					_.get(this.$store.state, 'selected_menu.primary_content.page_count')
				)
					? parseInt(this.$store.state.selected_menu.primary_content.page_count)
					: 14,
				filter: {
					id: _.get(this.$store.state, 'selected_menu.id'),
					placeName: 'primary',
					searchText: '',
					searchDate: [],
					searchTerms: _.get(
						this.$store.state.selected_menu,
						'primary_content.term'
					),
					pageNumber: 1,
					perPage: parseInt(
						_.get(this.$store.state, 'selected_menu.primary_content.page_count')
					)
						? parseInt(
								this.$store.state.selected_menu.primary_content.page_count
						  )
						: 14,
					taxonomy: 'news_category',
				},
				searchText: '',
				searchDate: [],
				searchSelect: '',
				noNewsText: false,
				pageChange: false,
				currentPage: 1,
				dataNoChnaged: [],
			};
		},
		watch: {
			filter: {
				deep: true,
				handler: function() {
					this.$store.dispatch('getPagedContent', this.filter);
				},
			},
		},
		computed: {
			mainList() {
				return _.get(this.$store.state, 'current_content.primary');
			},
			getNews() {
				let rangeArray = [];
				let rangeItems = [];
				let data = _.get(
					this.$store.state.current_content,
					'secondary.NewsMediaFilter.data'
				);

				// Check for vuex async error "can not read key of undefined"
				if (data !== undefined && data.length > 0) {
					// Check if searchData is not null
					if (this.searchDate !== null && this.searchDate.length > 0) {
						// Clone date ranges array
						rangeArray = JSON.parse(JSON.stringify(this.searchDate));
						// Turn range date items into number timestamps
						rangeItems = rangeArray.map((item) => {
							item = item.slice(0, 10);
							return new Date(item).getTime();
						});
					}
					// Filter data array with search input text
					data = data.filter(
						(item) =>
							item.title
								.toLowerCase()
								.indexOf(this.searchText.toLowerCase()) !== -1
					);
					// Filter data array with categories
					// data = data.filter(
					//   (item) =>
					//     item.news_category.includes(parseInt(this.searchSelect.id)) ||
					//     this.searchSelect.id === ""
					// );
					let searchSelect = this.searchSelect;
					data = data.filter(function(item) {
						let x = 0;
						if (searchSelect.id === undefined) {
							return true;
						} else {
							if (
								item.news_category.includes(parseInt(searchSelect.id)) ||
								searchSelect.id === ''
							) {
								return true;
							}
						}
					});
					this.dataNoChnaged = data;
					// Add timestamp range values to each object
					data = data
						.map((item) => {
							item.updated_at = moment(item.updated_at).format('DD MM YYYY');
							item.timeStampDate = new Date(item.updated_at).getTime();
							return item;
						})
						.slice(
							(this.currentPage - 1) * this.perPage,
							(this.currentPage - 1) * this.perPage + this.perPage
						); // slice data array with pagination value
					// Filter data array with time range
					if (this.searchDate.length > 0) {
						return data.filter(
							(item) =>
								item.timeStampDate > rangeItems[0] &&
								item.timeStampDate < rangeItems[1]
						);
					}
					return data;
				}
			},

			getDataLength() {
				if (
					parseInt(
						_.get(this.$store.state, 'current_content.primary_conf.listCount')
					)
				)
					return this.$store.state.current_content.primary_conf.listCount;
				return this.filter.perPage;

				// const data = _.get(
				//   this.$store.state.current_content,
				//   "secondary.NewsMediaFilter.data"
				// );
				const data = this.dataNoChnaged;
				if (data !== undefined && data.length > 0) {
					if (
						this.searchText === '' &&
						(this.searchDate.length === 0 || this.searchDate === null) &&
						this.searchSelect === ''
					) {
						return data.length;
					}
					// return this.getNews.length;
					return data.length;
				}
			},
		},
		mounted() {
			this.noNews();
		},
		methods: {
			getSearchText(str) {
				this.filter.searchText = str;
			},

			getSearchDate(date) {
				this.$set(this.filter, 'searchDate', date);
				this.$set(this.filter, 'pageNumber', 1);
			},

			getSearchSelect(cat) {
				this.$set(this.filter, 'searchTerms', cat);
				this.$set(this.filter, 'pageNumber', 1);
				// this.$set(this.filter, 'searchTerms', cat);
			},

			setCurrent(current) {
				if (!parseInt(current)) return this.$set(this.filter, 'pageNumber', 1);
				this.pageChange = true;
				setTimeout(() => {
					this.pageChange = false;
				}, 800);
				// window.scrollTo({top: 0, behavior: 'smooth'});
				// window.scrollTo(0, 0);
				let headerScroll = document.querySelector('#header-id');
				headerScroll.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
					inline: 'nearest',
				});
				this.$set(this.filter, 'pageNumber', current);
				// this.$set(this.filter, "searchTerms", this.searchTerms);
				setTimeout(() => {
					this.$store.commit('setState', {
						key: 'isClickedPagination',
						val: true,
					});
				}, 200);
				if (this.$store.state.newsAll) {
					window.history.pushState({}, null, '?all=1&page=' + current);
				} else {
					this.$store.commit('setState', { key: 'newsAll', val: false });
					window.history.pushState({}, null, '?page=' + current);
				}
				setTimeout(() => {
					this.$store.commit('setState', {
						key: 'isClickedPagination',
						val: false,
					});
					// this.$router.replace({query:{page: current}})
				}, 301);
			},
			noNews: function() {
				if (!_.size(this.mainList)) return false;
			},
		},
	};
</script>

<style scoped>
	.news-container,
	.news-section {
		opacity: 1;
		visibility: visible;
		transition: 0.5s ease;
	}
	.news-container.hide,
	.news-section.hide {
		opacity: 0;
		visibility: hidden;
		transition: 0.5s ease;
	}
</style>
